/* Website inquiry capture only. Never accepts quotes or places orders. */
(() => {
  const form = document.getElementById('UcsContactInquiry');
  if (!form) return;
  const cloud = form.dataset.mode === 'cloud';
  if (!cloud && form.dataset.preview !== 'test-capture') return;
  const type = document.getElementById('UcsInquiryType');
  const fields = document.getElementById('UcsSpecialOrderFields');
  const specifications = document.getElementById('UcsItemSpecifications');
  const specificationFields = document.getElementById('UcsItemSpecificationFields');
  const submit = document.getElementById('UcsInquirySubmit');
  const error = document.getElementById('UcsInquiryError');
  const confirmation = document.getElementById('UcsInquiryConfirmation');
  let requestKey = crypto.randomUUID();
  let frozenPayload = null;
  let frozenFiles = [];
  let busy = false;
  const controls = [...form.querySelectorAll('input,select,textarea')];
  function encodeFile(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onerror = () => reject(new Error('A reference file could not be read. Please select it again.'));
      reader.onload = () => resolve({ name: file.name, type: file.type, base64: String(reader.result).split(',')[1] });
      reader.readAsDataURL(file);
    });
  }
  function updateSpecifications() {
    specificationFields.disabled = fields.disabled || !specifications.open;
  }
  specifications.addEventListener('toggle', () => { if (!busy) updateSpecifications(); });
  function updateType() {
    const special = type.value === 'special-order';
    fields.hidden = !special;
    fields.disabled = !special;
    if (!special) specifications.open = false;
    updateSpecifications();
    submit.textContent = special ? 'Request a quote' : 'Send message';
    error.hidden = true;
  }
  type.addEventListener('change', updateType);
  form.addEventListener('submit', event => event.preventDefault());
  submit.addEventListener('click', async () => {
    if (busy) return;
    error.hidden = true;
    updateSpecifications();
    if ((!cloud && (location.origin !== 'http://127.0.0.1:9292' || form.dataset.endpoint !== 'http://127.0.0.1:4177/api/inquiries')) || (cloud && form.dataset.endpoint !== 'https://apps.universalchurchsupplies.ca/api/intake')) {
      error.textContent = 'Functional testing is available only in the UCS localhost preview. No request was sent.';
      error.hidden = false; return;
    }
    if (!frozenPayload && !form.reportValidity()) return;
    busy = true; submit.disabled = true; submit.textContent = 'Saving request...';
    try {
      if (!frozenPayload) {
        const data = new FormData(form);
        const files = [...document.getElementById('UcsInquiryFiles').files];
        if (files.length > 3) throw new Error('Please attach up to three reference files.');
        if (files.some(file => !file.size || file.size > 5 * 1024 * 1024)) throw new Error('Each file must be between 1 byte and 5 MB.');
        if (files.some(file => !['image/jpeg', 'image/png', 'application/pdf'].includes(file.type))) throw new Error('Please use JPG, PNG or PDF files.');
        controls.forEach(control => { control.disabled = true; });
        const candidate = { idempotencyKey: requestKey, acknowledged: data.get('acknowledged') === 'on' };
        for (const key of ['requestType','name','email','phone','organization','details','item','quantity','deadline','budget','alternatives','reference','website']) candidate[key] = String(data.get(key) || '');
        frozenFiles = files;
        candidate.files = cloud ? await Promise.all(files.map(async file => ({name: file.name, type: file.type, bytes: file.size, sha256: [...new Uint8Array(await crypto.subtle.digest('SHA-256', await file.arrayBuffer()))].map(byte => byte.toString(16).padStart(2,'0')).join('')}))) : await Promise.all(files.map(encodeFile));
        frozenPayload = candidate;
      }
      async function post(endpoint, payload) {
        const response = await fetch(endpoint, { method: 'POST', credentials: 'omit', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload), signal: AbortSignal.timeout(60000) });
        const result = await response.json();
        if (!response.ok) {
          if ([400,403,413,415].includes(response.status)) { frozenPayload = null; if (cloud) requestKey = crypto.randomUUID(); }
          if (response.status === 410) { frozenPayload = null; requestKey = crypto.randomUUID(); }
          throw new Error(result.error || 'The receiver could not confirm your request was saved.');
        }
        return result;
      }
      let result;
      if (cloud) {
        const prepared = await post(form.dataset.endpoint + '/prepare', frozenPayload);
        if (prepared.saved) result = prepared;
        else {
          if (!Array.isArray(prepared.uploads) || prepared.uploads.length !== frozenFiles.length) throw new Error('Reference upload session could not be verified.');
          for (const upload of prepared.uploads) {
            const file = frozenFiles[upload.index];
            const url = new URL(upload.url);
            if (url.protocol !== 'https:' || !url.hostname.endsWith('.r2.cloudflarestorage.com') || !file) throw new Error('Reference upload destination could not be verified.');
            const uploaded = await fetch(url.href, {method: 'PUT', credentials: 'omit', headers: {'Content-Type': file.type}, body: file, signal: AbortSignal.timeout(60000)});
            if (!uploaded.ok) throw new Error('A reference file could not be uploaded. Retry this same request.');
          }
          result = await post(form.dataset.endpoint + '/complete', {idempotencyKey: frozenPayload.idempotencyKey, token: prepared.token});
        }
      } else result = await post(form.dataset.endpoint, frozenPayload);
      const kind = frozenPayload.requestType === 'general' ? 'INQ' : 'SO';
      if (cloud ? (result.saved !== true || result.reference !== 'WEB-' + frozenPayload.idempotencyKey.toUpperCase()) : (result.testMode !== true || !new RegExp(`^TEST-${kind}-\\d{4}-\\d{3,}$`).test(result.reference))) throw new Error('The saved reference could not be verified.');
      if (cloud && result.shortReference !== undefined && !/^WEB-\d{6,10}$/.test(result.shortReference)) throw new Error('The saved reference could not be verified.');
      document.getElementById('UcsInquirySavedReference').textContent = result.shortReference || result.reference;
      form.hidden = true;
      confirmation.hidden = false;
      confirmation.focus();
    } catch (problem) {
      if (!frozenPayload) {
        controls.forEach(control => { control.disabled = false; });
        updateType();
      }
      error.textContent = problem.message || 'We could not confirm that your request was saved.';
      if (frozenPayload) error.textContent += ' Your details are locked. Retry this same request to avoid a duplicate; do not start a new request yet.';
      error.hidden = false;
    } finally {
      busy = false; submit.disabled = false;
      submit.textContent = frozenPayload && !form.hidden ? 'Retry saving request' : type.value === 'special-order' ? 'Request a quote' : 'Send message';
    }
  });
  document.getElementById('UcsInquiryReset').addEventListener('click', () => {
    form.reset();
    specifications.open = false;
    requestKey = crypto.randomUUID(); frozenPayload = null; frozenFiles = [];
    controls.forEach(control => { control.disabled = false; });
    document.getElementById('UcsInquirySavedReference').textContent = '';
    updateType();
    confirmation.hidden = true;
    form.hidden = false;
    document.getElementById('UcsInquiryName').focus();
  });
  updateType();
})();
